type Props = {
  className?: string;
};

export const SeemsAvailable = (props: Props) => {
  return (
    <svg
      {...props}
      width={36}
      height={40}
      viewBox="0 0 45 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44 27V47.75L14.7863 53L1.65649 40.5L1 19.5L30.2137 15L44 27Z"
        fill="#E9CD44"
      />
      <path
        d="M14.7863 53V31.75M14.7863 53L44 47.75V27M14.7863 53L1.65649 40.5L1 19.5M14.7863 31.75L44 27M14.7863 31.75L1 19.5M44 27L30.2137 15L1 19.5"
        stroke="black"
        strokeWidth="0.656489"
      />
      <path
        d="M1.66667 40.75L15 53V32L1 20L1.66667 40.75Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M14.7863 31.9098V53L44 47.7895V27.4436L14.7863 31.9098Z"
        fill="black"
        fillOpacity="0.15"
      />
      <g filter="url(#filter0_d_2132_6767)">
        <rect
          x="10"
          y="3"
          width="24"
          height="24"
          rx="12"
          fill="#937F27"
        />
        <rect
          x="10.5625"
          y="3.5625"
          width="22.875"
          height="22.875"
          rx="11.4375"
          stroke="white"
          strokeWidth="1.125"
        />
        <path
          d="M21.5781 16.6875V16.2241C21.5781 15.4759 22.0072 14.794 22.6817 14.4702C24.2351 13.7246 24.124 11.4769 22.5047 10.888L22.2943 10.8115C21.0635 10.364 19.7358 11.1758 19.5734 12.4754L19.4688 13.3125"
          stroke="white"
          strokeWidth="1.125"
          strokeLinecap="round"
        />
        <circle
          cx="21.5781"
          cy="19.9219"
          r="0.421875"
          fill="white"
          stroke="white"
          strokeWidth="0.375"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2132_6767"
          x="5"
          y="0"
          width="34"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2132_6767"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2132_6767"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
